"use client";

import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes } from "react";
const sizes = {
  sm: {
    wh: 8,
    c: 4,
    r: 2.5
  },
  md: {
    wh: 10,
    c: 5,
    r: 4
  }
};
export const Dot = t0 => {
  const $ = _c(13);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? "md" : t1;
  const t2 = sizes[size];
  const t3 = sizes[size];
  const t4 = `0 0 ${sizes[size].wh} ${sizes[size].wh}`;
  const t5 = sizes[size];
  const t6 = sizes[size];
  const t7 = sizes[size];
  let t8;
  if ($[3] !== t5.c || $[4] !== t6.c || $[5] !== t7.r) {
    t8 = <circle cx={t5.c} cy={t6.c} r={t7.r} fill="currentColor" stroke="currentColor" />;
    $[3] = t5.c;
    $[4] = t6.c;
    $[5] = t7.r;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== props || $[8] !== t2.wh || $[9] !== t3.wh || $[10] !== t4 || $[11] !== t8) {
    t9 = <svg width={t2.wh} height={t3.wh} viewBox={t4} fill="none" {...props}>{t8}</svg>;
    $[7] = props;
    $[8] = t2.wh;
    $[9] = t3.wh;
    $[10] = t4;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};